<template>
  <div>
    <b-button class="transparent small google-maps-button location-button"
              @click="showModal = true"> {{ $t('googleMapsModal.verMapa') }} </b-button>
    <modal-template v-if="showModal"
                    :title="'Mapa'"
                    @close="showModal = false">
      <w-google-map :location="location" />
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'
import WGoogleMap from '@/components/w-google-map/WGoogleMap.vue'

export default {
  components: {
    ModalTemplate,
    WGoogleMap
  },
  props: {
    location: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    showModal: false
  })
}
</script>

<style lang="scss">
@import './google-maps.sass';
</style>
